import { Component, Input, ChangeDetectionStrategy, inject } from "@angular/core";
import { LinkHelperService } from "../../../services/link-helper.service";
import { NewTabInModalDirective } from "../../../directives/new-tab-in-modal.directive";
import { RouterLink } from "@angular/router";


@Component({
    selector: "rl-entity-link",
    templateUrl: "./entity-link.component.html",
    styleUrls: ["./entity-link.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NewTabInModalDirective, RouterLink]
})
export class EntityLinkComponent {
	readonly linkHelper = inject(LinkHelperService);

	@Input()
	title: string;

	@Input()
	charTypeId: number;

	@Input()
	recordId: number;

	@Input()
	recordRevisionId: number;

}
